const getHome = (ajaxinstance) => {
  const customer = {}

  // 获取第一页内容--------------
  customer.question = (postData) => {
    return ajaxinstance.post('/index/question/index', postData)
  }
  // 保存第一页信息--------------
  customer.saveOne = (postData) => {
    return ajaxinstance.post('/index/question/saveOne', postData)
  }

  return customer
}

export default getHome



// WEBPACK FOOTER //
// ./src/common/apis/home.js